// Copyright (c) 2016 Deere & Company

import ClaimAction, {getDefaultState as getClaimActionDefaultState} from './claim-action';
import ClaimAdditionalFailureInfo, {getDefaultState as getClaimAdditionalFailureInfoDefaultState} from './claim-additional-failure-info';
import ClaimComplaintCause, {getDefaultState as getClaimComplaintCauseDefaultState} from './claim-complaint-cause';
import ClaimFailureInfo, {getDefaultState as getClaimFailureInfoDefaultState} from './claim-failure-info';
import ClaimRecordInfo, {getDefaultState as getClaimClaimRecordInfoDefaultState} from './claim-record-info';
import ClaimReferenceInfo, {getDefaultState as getClaimReferenceInfoDefaultState} from './claim-reference-info';
import ClaimReimbursementDetails, {getDefaultState as getClaimReimbursementDetailsDefaultState} from './claim-reimbursement-details';
import ClaimRgaStatus, {getDefaultState as getClaimRgaStatusDefaultState} from './claim-rga-status';
import ClaimRules, {getDefaultState as getClaimRulesDefaultState} from './claim-rules';
import ClaimValueDetails, {getDefaultState as getClaimValueDetailsDefaultState} from './claim-value-details';
import CustomerSummary, {getDefaultState as getCustomerSummaryDefaultState} from './customer-summary';
import Dealer, {getDefaultState as getDealerDefaultState} from './dealer';
import KeyValuePair, {getDefaultState as getKeyValuePairDefaultState} from './key-value-pair';
import ClaimLabor from './claim-item-labor';
import ClaimOtherCredit from './claim-item-other-credit';
import ClaimPart from './claim-item-part';
import ClaimUseAmount from './claim-use-amount';
import ClaimVsrMessage from './claim-vsr-message';
import File from './file';
import t from 'tcomb';

const ClaimNormal = t.struct({
    additionalFailureInfo: ClaimAdditionalFailureInfo,
    allowedActions: t.list(ClaimAction, 'AllowedActions'),
    applyTravel: t.Bool,
    claimNumber: t.String,
    claimStatus: KeyValuePair,
    claimType: KeyValuePair,
    claimValueDetails: ClaimValueDetails,
    complaintCauseCommentsBasis: ClaimComplaintCause,
    customerSummary: CustomerSummary,
    errors: t.list(ClaimVsrMessage, 'Errors'),
    failureInfo: ClaimFailureInfo,
    file: t.maybe(t.list(File, 'Files')),
    goodsInstallationVat: t.maybe(KeyValuePair),
    hideClaimValueDetails: t.Bool,
    isDuplicateClaim: t.Bool,
    isEditable: t.Bool,
    labor: t.maybe(t.list(ClaimLabor, 'Labor')),
    otherCredits: t.maybe(t.list(ClaimOtherCredit, 'OtherCredits')),
    parts: t.maybe(t.list(ClaimPart, 'Parts')),
    pin: t.String,
    recordInfo: ClaimRecordInfo,
    referenceInfo: ClaimReferenceInfo,
    reimbursementDetails: ClaimReimbursementDetails,
    responsibleAccount: Dealer,
    rgaStatus: ClaimRgaStatus,
    rules: ClaimRules,
    selectedAction: ClaimAction,
    showAmountsInLocalCurrency: t.Bool,
    showGoodsInstallationVat: t.Bool,
    showValidate: t.Bool,
    useAmounts: t.list(ClaimUseAmount, 'UseAmounts'),
    validationFailed: t.Bool,
    version: t.String
}, {
    name: 'ClaimNormal',
    strict: true
});

export const getDefaultState = () => new ClaimNormal({
    additionalFailureInfo: getClaimAdditionalFailureInfoDefaultState(),
    allowedActions: [
        new ClaimAction({
            actionName: 'DRAFT',
            id: 'DRAFT',
            mode: 'CHG'
        })
    ],
    applyTravel: false,
    claimNumber: '',
    claimStatus: getKeyValuePairDefaultState(),
    claimType: new KeyValuePair({
        key: 'ZNRM',
        value: ''
    }),
    claimValueDetails: getClaimValueDetailsDefaultState(),
    complaintCauseCommentsBasis: getClaimComplaintCauseDefaultState(),
    customerSummary: getCustomerSummaryDefaultState(),
    errors: [],
    failureInfo: getClaimFailureInfoDefaultState(),
    file: [],
    goodsInstallationVat: getKeyValuePairDefaultState(),
    hideClaimValueDetails: false,
    isDuplicateClaim: false,
    isEditable: true,
    labor: [],
    otherCredits: [],
    parts: [],
    pin: '',
    recordInfo: getClaimClaimRecordInfoDefaultState(),
    referenceInfo: getClaimReferenceInfoDefaultState(),
    reimbursementDetails: getClaimReimbursementDetailsDefaultState(),
    responsibleAccount: getDealerDefaultState(),
    rgaStatus: getClaimRgaStatusDefaultState(),
    rules: getClaimRulesDefaultState(),
    selectedAction: getClaimActionDefaultState(),
    showAmountsInLocalCurrency: false,
    showGoodsInstallationVat: false,
    showValidate: true,
    useAmounts: [],
    validationFailed: false,
    version: ''
});

ClaimNormal.prototype.vsrErrorMessages = function vsrErrorMessages() {

    return this.errors.filter(vsrMessage => vsrMessage.type.key === 'E');

};

ClaimNormal.prototype.vsrWarningMessages = function vsrWarningMessages() {

    return this.errors.filter(vsrMessage => vsrMessage.type.key === 'W');

};

ClaimNormal.prototype.vsrInfoMessages = function vsrInfoMessages() {

    return this.errors.filter(vsrMessage => vsrMessage.type.key === 'I');

};

export default ClaimNormal;



// WEBPACK FOOTER //
// ./~/@deere/cps-it.warranty-model-factory/lib/claim-normal.js